import { initStore } from './store';

const ConfigureStore = () => {
    const actions = {
        SetAccessRight: (curState, accessRight) => {
            return { accessRight: accessRight };
        },
        SetMenuState: (curState, menuState) => {
            return { menuState: menuState };
        },
        SetAccessPage: (curState, accessPage) => {
            return { accessPage: accessPage };
        },
        SetCompany: (curState, company) => {
            return { company: company };
        }               
    };
    initStore(actions, { accessRight: [], menuState: [], company: [], accessPage: [] });
};


export default ConfigureStore;